export const OPEN_US_MODAL = 'openUsModal';
export const ADDED_DELIVERY_PASS = 'addedDeliveryPass';
